{
  "qr-checkin-config-page": {
    "buttons": {
      "check-in": "CHECK IN"
    },
    "meta": {
      "title": "QR Check in",
      "description": "Check in via QR code",
      "checkin-hint": "(Optional) You can choose your service before check-in"
    }
  }
}
